exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../../css-loader/dist/cjs.js??ref--8-1!@notes/sticky-notes-sdk/dist-es2015/styles/custom-properties.css"), "");
exports.i(require("-!../../../../../../css-loader/dist/cjs.js??ref--8-1!@notes/sticky-notes-sdk/dist-es2015/styles/mixins/icon.css"), "");
// Module
exports.push([module.id, "._2G5JSYZ2Aq7uJlz00cWv4Q{color:var(--onenote-purple);-ms-flex-item-align:end;align-self:flex-end;position:relative;& svg{width:16px;height:16px}}._19PtzOY2pRMkkDQ47A7caY{cursor:pointer}html[dir] ._19PtzOY2pRMkkDQ47A7caY{margin:0;padding:0}@mixin keyboardNavigating{._2Bj_iVeDE9BHtOT5LnvVM4{@mixin iconFocused}}", ""]);
// Exports
exports.locals = {
	"n-newNoteButtonSpan": "_2G5JSYZ2Aq7uJlz00cWv4Q",
	"n-newNoteButtonContainer": "_19PtzOY2pRMkkDQ47A7caY",
	"n-newNoteButtonIcon": "_2Bj_iVeDE9BHtOT5LnvVM4"
};